import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './blog-content.module.sass';
import { Typography, Row, Col, Button, Image } from 'antd';
import { Link } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { STATUS } from '../../../../redux/constants';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import { BackToTopButton } from '../../../../shared-components/BackToTopButton';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';
import { useDispatch } from 'react-redux';

function BlogContent(props) {
  const { Title, Text } = Typography;
  const {
    blog,
    blogStatus,
    amberReportFeeds,
    setTagSearchValue,
    changeBlogTitle,
  } = props;
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const q = useQuery();
  const containerRef = useRef(null);
  const dispatch = useDispatch();

  function useQuery() {
    return new URLSearchParams(window.location.search);
  }

  function handleBack() {
    history.push(`/blog`);
  }

  useEffect(() => {
    const postName = q?.get('post');
    const postUuid = q?.get('uuid');
    const feedName = q?.get('name');

    if (postName) {
      // setPostOpened(true);
      if (
        postUuid &&
        props?.mySubscriptionPlan?.has_access_to_tlp_amber_report
      ) {
        props.loadAmberReport(postUuid);
      }
    } else {
      // setPostOpened(false);
      // if (amberReportCount?.count === 0) {
      // setMarkAllAsSeenVisible(false);
      // }
      changeBlogTitle('TLP Amber Reports');
      document.title = `TLP Amber Reports - Silent Push`;
    }

    // if (feedName) {
    //   setFeedSearchValue(feedName);
    // }
  }, [window.location.search]);

  useEffect(() => {
    if (blogStatus === STATUS.LOADED) {
      document.title = `${blog?.title} - Silent Push`;
      changeBlogTitle(
        blog?.title ? blog.title : 'TLP Amber Reports - Silent Push',
      );

      setTimeout(() => {
        setLoaded(true);
        applyImagesPreview();
      }, 100);
    }
  }, [blogStatus]);

  const applyImagesPreview = () => {
    if (containerRef.current) {
      const images = containerRef.current.querySelectorAll('img');
      if (images) {
        images.forEach((img) => {
          const antdImage = document.createElement('div');
          const originalWidth = img.width;
          antdImage.className = 'antd-image'; // Add any additional class or style as needed
          img.parentNode.replaceChild(antdImage, img);
          ReactDOM.render(
            <div className={styles?.imageContainer}>
              <Image width={originalWidth} src={img.src} />
            </div>,
            antdImage,
          );
        });
      }
    }
  };

  const HTMLRenderer = ({ htmlString }) => {
    return (
      <div
        ref={containerRef}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      ></div>
    );
  };

  return blogStatus === STATUS.LOADED ? (
    <div
      key={blog?.uuid}
      className={cx(styles.blogContent, { [styles.loaded]: loaded })}
    >
      <Button type="ghost" className="mb-1" onClick={() => handleBack()}>
        <LeftOutlined /> Back
      </Button>

      <Row gutter={24} className={'mb-1'}>
        <Col xs={24}>
          {blog?.title && (
            <Title className={styles.title} level={2}>
              {blog?.title}
            </Title>
          )}
        </Col>

        <Col xs={24} className={styles.infoColumn}>
          {blog?.date && (
            <Text className={cx(styles.info, 'me-05')}>
              <Text className="me-05">Published: </Text>
              {moment(blog.date).format('YYYY-MM-DD HH:mm')}
            </Text>
          )}

          {blog?.feedsData?.length > 0 && (
            <Text className={cx(styles.info, 'ms-05')}>
              Related Feed(s):{' '}
              {blog?.feedsData?.map((feed, index) => {
                const feedUUID = amberReportFeeds.filter(
                  (f) => f.label === feed.name,
                )?.[0]?.value;

                return (
                  <Link
                    to={'/?feed=' + feedUUID}
                    className={'ms-05'}
                    onClick={() => {
                      props.closeFilterSidebar();
                      props.applyFilters(null);
                      props.updateTag(null);
                      props.updateIocList({
                        pagination: props?.threatRankingListPagination,
                        sorting: props?.threatRankingListSorting,
                        filters: {
                          feed: [feedUUID],
                        },
                      });
                    }}
                  >
                    {feed?.name}
                    {blog?.feedsData?.length > 1 &&
                      index !== blog?.feedsData?.length - 1 &&
                      ','}
                  </Link>
                );
              })}
            </Text>
          )}

          {blog?.tagsData?.length > 0 && (
            <Text className={cx(styles.info, 'ms-1')}>
              Tags:{' '}
              {blog?.tagsData?.map((tag, index) => {
                return (
                  <>
                    <Text
                      className={cx(styles.tag, 'ms-05')}
                      onClick={(e) => {
                        setTagSearchValue(e.target.innerText);
                        window.history.replaceState(null, '', '/blog');
                        incrementUIRequestsCounter();
                      }}
                      data-cy="blogContentTag"
                    >
                      {tag.tag}
                    </Text>
                    {blog?.tagsData?.length > 1 &&
                      index !== blog?.tagsData?.length - 1 &&
                      ','}
                  </>
                );
              })}
            </Text>
          )}
        </Col>

        <Col xs={24}>
          {blog?.content && (
            <div className={styles.content}>
              <HTMLRenderer htmlString={blog?.content} />
            </div>
          )}
        </Col>

        <BackToTopButton />
      </Row>

      <div className={styles.logoBackground}></div>
    </div>
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default BlogContent;
